exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toast[data-v-ff328784]{position:fixed;right:12px;top:12px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:300px;height:80px;padding:27px 22px;z-index:100;font-size:12.5px;font-weight:600;letter-spacing:.6px;line-height:18px;text-transform:uppercase;background-color:#66bf44;-webkit-box-shadow:1px 1px 2px 0 rgba(0,0,0,.3);box-shadow:1px 1px 2px 0 rgba(0,0,0,.3);border-radius:3px;color:#fff}.toast img[data-v-ff328784]{margin-right:14px}.toast span[data-v-ff328784]{margin:1px 0 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ff328784","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/frontend/js/components/Toast.vue
// module id = JC/A
// module chunks = 1